import DocumentsContainer from './DocumentsContainer';
import DocumentsTableContainer from './DocumentsTableContainer';
import DocumentsDetailContainer from './DocumentsDetailContainer';
import DocumentInfoContainer from './DocumentInfoContainer';

export { DocumentsContainer, DocumentsTableContainer, DocumentsDetailContainer, DocumentInfoContainer };



// WEBPACK FOOTER //
// ./src/ui/features/Documents/containers/index.js